import React, { ReactNode } from 'react';
import styled from 'styled-components';
import { log } from '../../api';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

interface Props {
  children?: React.ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
  error?: Error;
}

export class ErrorBoundary extends React.Component<Props, ErrorBoundaryState> {
  state: ErrorBoundaryState = { hasError: false };

  static getDerivedStateFromError(error: Error): Partial<ErrorBoundaryState> {
    log('ErrorBoundary/unknown', error);
    return {
      hasError: true,
      error,
    };
  }

  render(): ReactNode {
    const { hasError } = this.state;
    if (hasError) {
      return (
        <Container>
          <h2>An unknown error occurred.</h2>
          <button onClick={() => window.location.reload()}>Reload</button>
        </Container>
      );
    }

    return this.props.children;
  }
}
